/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_BodyInputs */

const en_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A science-based framework for every player. Six steps. Three decades of teaching in Des Moines.`)
};

const es_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un enfoque basado en la ciencia para cada jugador. Seis pasos. Tres décadas enseñando en Des Moines.`)
};

const de_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein wissenschaftlich fundierter Rahmen für jeden Spieler. Sechs Schritte. Drei Jahrzehnte Lehrtätigkeit in Des Moines.`)
};

const zh_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合每一位球员、以科学为基础的方法。六个步骤。在得梅因执教三十年。`)
};

const ar_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إطار قائم على العلم لكل لاعب. ست خطوات. ثلاثة عقود من التعليم في Des Moines.`)
};

const fr_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un cadre scientifique pour chaque joueur. Six étapes. Trois décennies d'enseignement à Des Moines.`)
};

const vi_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khung khoa học cho mọi người chơi. Sáu bước. Ba thập kỷ giảng dạy tại Des Moines.`)
};

const sw_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mfumo unaotegemea sayansi kwa kila mchezaji. Hatua sita. Miongo mitatu ya mafundisho katika Des Moines.`)
};

const th_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอบการทำงานตามหลักวิทยาศาสตร์สำหรับผู้เล่นทุกคน หกขั้นตอน สามทศวรรษของการสอนในดิมอยน์`)
};

const bs_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okvir zasnovan na nauci za svakog igrača. Šest koraka. Tri decenije poučavanja u Des Moinesu.`)
};

const ja_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのプレーヤーのための科学に基づくフレームワーク。6つのステップ。Des Moinesでの30年の指導。`)
};

const ko_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 플레이어를 위한 과학 기반 프레임워크. 6단계. Des Moines에서 쌓아온 30년의 가르침.`)
};

const pt_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma metodologia científica para cada jogador. Seis passos. Três décadas de ensino em Des Moines.`)
};

const it_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una struttura basata sulla scienza per ogni giocatore. Sei passi. Tre decenni di insegnamento in Des Moines.`)
};

const sv_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ett vetenskapsbaserat ramverk för varje spelare. Sex steg. Tre decennier av undervisning i Des Moines.`)
};

const nl_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een wetenschappelijke basis voor elke speler. Zes stappen. Drie decennia lesgeven in Des Moines.`)
};

const da_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En videnskabsbaseret ramme for hver spiller. Seks skridt. Tre årtiers undervisning i Des Moines.`)
};

const nb_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vitenskapelig ramme for alle spillere. Seks skritt. Tre tiårs undervisning i Des Moines.`)
};

const fi_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedepohjainen kehys jokaiselle pelaajalle. Kuusi askelta. Kolme vuosikymmentä opetusta Des Moinesissa.`)
};

const pl_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ramy oparte na wiedzy dla każdego gracza. Sześć kroków. Trzy dekady nauczania w Des Moines.`)
};

const ru_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научная основа для каждого игрока. Шесть шагов. Три десятилетия преподавания в Des Moines.`)
};

const tr_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her oyuncu için bilim temelli bir çerçeve. Altı adım. Des Moines’de üç on yıllık öğretim.`)
};

const hi_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक खिलाड़ी के लिए एक विज्ञान आधारित ढांचा। छह चरण Des Moines में तीन दशकों की शिक्षा।`)
};

const id_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebuah kerangka berbasis ilmu untuk setiap pemain. Enam langkah. Tiga dekade mengajar di Des Moines.`)
};

const ms_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangka kerja berasaskan sains untuk setiap pemain. Enam langkah. Tiga dekad mengajar di Des Moines.`)
};

const cs_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rámec založený na vědě pro každého hráče. Šest kroků. Tři desetiletí výuky v Des Moines.`)
};

const el_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ένα επιστημονικό πλαίσιο για κάθε παίκτη. Έξι βήματα. Τρεις δεκαετίες διδασκαλίας στο Des Moines.`)
};

const he_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מסגרת מדעית לכל שחקן. שישה צעדים שלושה עשורים של הוראה ב Des Moines.`)
};

const af_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'n Wetenskaplike raamwerk vir elke speler. Ses stappe. Drie dekades se onderrig in Des Moines.`)
};

const hu_home_hero_body = /** @type {(inputs: Home_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudományon alapuló keret minden játékosnak. Hat lépés. Három évtizednyi tanítás Des Moines-ben.`)
};

/**
* | output |
* | --- |
* | "A science-based framework for every player. Six steps. Three decades of teaching in Des Moines." |
*
* @param {Home_Hero_BodyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_hero_body = /** @type {((inputs?: Home_Hero_BodyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_BodyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_body(inputs)
	if (locale === "de") return de_home_hero_body(inputs)
	if (locale === "zh") return zh_home_hero_body(inputs)
	if (locale === "ar") return ar_home_hero_body(inputs)
	if (locale === "fr") return fr_home_hero_body(inputs)
	if (locale === "vi") return vi_home_hero_body(inputs)
	if (locale === "sw") return sw_home_hero_body(inputs)
	if (locale === "th") return th_home_hero_body(inputs)
	if (locale === "bs") return bs_home_hero_body(inputs)
	if (locale === "ja") return ja_home_hero_body(inputs)
	if (locale === "ko") return ko_home_hero_body(inputs)
	if (locale === "pt") return pt_home_hero_body(inputs)
	if (locale === "it") return it_home_hero_body(inputs)
	if (locale === "sv") return sv_home_hero_body(inputs)
	if (locale === "nl") return nl_home_hero_body(inputs)
	if (locale === "da") return da_home_hero_body(inputs)
	if (locale === "nb") return nb_home_hero_body(inputs)
	if (locale === "fi") return fi_home_hero_body(inputs)
	if (locale === "pl") return pl_home_hero_body(inputs)
	if (locale === "ru") return ru_home_hero_body(inputs)
	if (locale === "tr") return tr_home_hero_body(inputs)
	if (locale === "hi") return hi_home_hero_body(inputs)
	if (locale === "id") return id_home_hero_body(inputs)
	if (locale === "ms") return ms_home_hero_body(inputs)
	if (locale === "cs") return cs_home_hero_body(inputs)
	if (locale === "el") return el_home_hero_body(inputs)
	if (locale === "he") return he_home_hero_body(inputs)
	if (locale === "af") return af_home_hero_body(inputs)
	if (locale === "hu") return hu_home_hero_body(inputs)
	return en_home_hero_body(inputs)
});